import { useCallback, useLayoutEffect } from 'react';

const useAutoResize = (textareaRef, { minRows = 3, maxRows = 6, value } = {}) => {
    const adjustHeight = useCallback(() => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const computedStyle = window.getComputedStyle(textarea);
        const lineHeight = parseFloat(computedStyle.lineHeight) || 20;
        const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
        const borderTop = parseFloat(computedStyle.borderTopWidth) || 0;
        const borderBottom = parseFloat(computedStyle.borderBottomWidth) || 0;

        const verticalPadding = paddingTop + paddingBottom + borderTop + borderBottom;
        const minHeight = minRows * lineHeight + verticalPadding;
        const maxHeight = maxRows * lineHeight + verticalPadding;

        textarea.style.height = 'auto';
        textarea.style.overflowY = 'hidden';

        const scrollHeight = textarea.scrollHeight;
        const newHeight = Math.min(Math.max(scrollHeight, minHeight), maxHeight);

        textarea.style.height = `${newHeight}px`;

        if (scrollHeight > maxHeight) {
            textarea.style.overflowY = 'auto';
        }
    }, [textareaRef, minRows, maxRows]);

    useLayoutEffect(() => {
        adjustHeight();
    }, [adjustHeight, value]);

    return adjustHeight;
};

export default useAutoResize;
